import {createError, handleServerErrors} from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import { assertArray } from "core/validation";
import { toast } from "react-toastify";
import { call, cancelled, delay, fork, put, select, takeLatest } from "redux-saga/effects";
import ApiImportService from "services/apiImportService";
import { ApiSearchParamsSelector, actions } from "./actions";

import { get } from "lodash";
import envconfig from "../../../../envconfig";
import {DATE_FORMAT_SHORT, DATE_FORMAT_TEXT_INPUT, formatDate} from "components/common/dateUtils";

export function formatSearchParams(params) {
    return {
        filmDateEnteredBegin: params.dateStart ? formatDate(params.dateStart, DATE_FORMAT_SHORT) : null,
        filmDateEnteredEnd: params.dateEnd ? formatDate(params.dateEnd, DATE_FORMAT_SHORT): null,
    };
}
export function formatDataList(data) {
    return assertArray(data)
        ? data.map((d) => {
            const enteredDate = get(d, "enteredDate", null);
            const releaseDate = get(d, "releaseDate", null);

            const enteredDateFormatted = enteredDate ? formatDate(enteredDate, DATE_FORMAT_TEXT_INPUT) : "";
            const releaseDateFormatted = releaseDate ? formatDate(releaseDate, DATE_FORMAT_TEXT_INPUT) : "";
            return {
                ...d,
                enteredDateFormatted,
                releaseDateFormatted,
            };
        })
        : [];
}
export function* onSearch() {
    try {
        const paramsSelect = yield select(ApiSearchParamsSelector);
        const params = formatSearchParams(paramsSelect);
        const data = yield call(ApiImportService.loadFilms, params);
        const convertedData = formatDataList(data);
        yield put(actions.ON_SEARCH_API_FILM.success({ data: convertedData }));
    } catch (e) {
        yield put(actions.ON_SEARCH_API_FILM.failed(null, createError(e)));
    }
}

export function* _reload() {
    yield put(actions.ON_SEARCH_API_FILM.send());
}

export function* onMatchFilms({ payload }) {
    try {
        const { selectedId, externalId } = payload;
        yield call(ApiImportService.matchFilms, externalId, selectedId);
        yield put(actions.ON_MATCH_FILM.success());
        toast.success("The film has been accepted", {
            position: "top-right"
        });
        yield fork(_reload);
        yield fork(requestCountImports);
    } catch (e) {
        handleServerErrors(e, () => {
            toast.error("Error accepting the film. Please try again", {
                position: "top-right"
            });
        });
        yield put(actions.ON_MATCH_FILM.failed(null, createError(e)));
    }
}
export function* onAcceptFilms({ payload }) {
    try {
        const form = payload.form;
        yield call(ApiImportService.submitAccept, form);
        yield put(actions.ON_ACCEPT_FILM.success());
        toast.success("The film has been accepted", {
            position: "top-right"
        });
        yield fork(_reload);
        yield fork(requestCountImports);
    } catch (e) {
        handleServerErrors(e, () => {
            toast.error("Error accepting the film. Please try again", {
                position: "top-right"
            });
        });
        yield put(actions.ON_ACCEPT_FILM.failed(null, createError(e)));
    }
}

export function* loadApiCountTask() {
    try {
        while (true) {
            yield call(requestCountImports);
            yield delay(envconfig.API_IMPORT_DEBOUNCE);
        }
    } finally {
        if (yield cancelled()) {
            yield call(resetApiCount);
        }
    }
}
export function* requestCountImports() {
    const result = yield call(ApiImportService.countFilmsToAccept);
    const count = result || 0;
    yield put(actions.SET_API_COUNT.call(count));
}
export function* resetApiCount() {
    yield put(actions.SET_API_COUNT.call(0));
}

export default [
    ...createSagasForBasicCall(actions),
    takeLatest(actions.ON_SEARCH_API_FILM.sendType, onSearch),
    takeLatest(actions.ON_ACCEPT_FILM.sendType, onAcceptFilms),
    takeLatest(actions.ON_MATCH_FILM.sendType, onMatchFilms),
];
